const dashboardPageName = "Dashboard";
const schedulePageName = "Today's Schedule";
const realTimePageName = "Real Time";
const monitoringPageName = "Safety Monitoring";
const entryPageName = "Entry";
const projectPageName = "Project";
const contractPageName = "Contract";
const equipmentPageName = "Equipment";
const workPageName = "Work Record";
const workerPageName = "Worker";
const alertPageName = "Edit Alert";
const companyPageName = "Company";
const internalReportPageName = "Internal Report";
const reportPageName = "Report";
const userPageName = "User";

export {
    dashboardPageName,
    schedulePageName,
    realTimePageName,
    monitoringPageName,
    entryPageName,
    projectPageName,
    contractPageName,
    equipmentPageName,
    workPageName,
    workerPageName,
    alertPageName,
    companyPageName,
    reportPageName,
    internalReportPageName,
    userPageName,
};
